import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Geo",
  "use": "Geo-usage",
  "viewBox": "0 0 44 62",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 62\" id=\"Geo\"><path fill-rule=\"evenodd\" d=\"M14 21c0-4.488 3.512-8 8-8 4.468 0 8 3.512 8 8 0 4.468-3.532 8-8 8-4.488 0-8-3.532-8-8zm-14 .708C0 37.828 22.01 62 22.01 62S44 37.828 44 21.708C44 9.61 34.256 0 22.01 0 9.744 0 0 9.61 0 21.708zm3 .04c0 13.921 19.008 34.797 19.008 34.797S41 35.67 41 21.748C41 11.3 32.585 3 22.008 3 11.415 3 3 11.3 3 21.748z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol